export const createPinnedItem = ({ 
  x = 0, 
  y = 0, 
  w = 0, 
  h = 0,
  i = ''
}) => {
  return {
    x,
    y,
    w,
    h,
    i
  };
};

export class PinnedGrid {
  
  constructor(width, 
    height = 1000, 
    padding = 10,
    startX = 30,
    startY = 10
  ) {
    this.items = [];
    this.width = width;
    this.height = height;
    this.padding = padding;
    this.startX = startX;
    this.startY = startY;
  }

  detectCollision(b1, b2) {
    if (
      b2.x > b1.x + b1.w ||
      b2.y > b1.y + b1.h ||
      b2.x + b2.w < b1.x ||
      b2.y + b2.h < b1.y
    ) {
      return false;
    } else {
      return true;
    }
  }

  calculate (item) {

    const itemWidth = item.w;
    const itemHeight = item.h;

    let coords = {x: 0, y : 0};

    let dc = false;
    for (let yi = this.startY; yi < this.height - itemHeight; yi+= this.padding) {

      for(let xi = this.startX; xi < this.width - itemWidth; xi+= this.padding) {
        dc = this.items.every(e => (!this.detectCollision(e, {
          x: xi,
          y: yi
        })));
        if (dc) {
          coords = {x: xi, y: yi};
          break;
        }
      }
      if (dc) {
        break;
      }
    }
    if (dc) {
      return {
        ...coords,
      };
    }else {
      return false;
    }
  };
  addItem (item) {
    const coords = this.calculate(item);

    if (coords) {
      this.items.push({...item, ...coords});
    }

    return coords;
  };
  removeById(id) {
    this.items = this.items.filter(x => x.i !== id);
  }
  pushItem (item) {
    this.items.push(item);
  };
};

// const pinnedGrid = new PinnedGrid(400);

// pinnedGrid;

// pinnedGrid.addItem(createPinnedItem({
//   x: 0,
//   y: 0,
//   w: 300,
//   h: 200
// }));

// console.log(pinnedGrid);

// console.log(pinnedGrid.addItem(createPinnedItem({
//   w: 200, 
//   h: 100
// })));
// console.log(pinnedGrid.addItem(createPinnedItem({
//   w: 200, 
//   h: 100
// })));
// console.log(pinnedGrid.addItem(createPinnedItem({
//   w: 200, 
//   h: 100
// })));
// console.log(pinnedGrid.addItem(createPinnedItem({
//   w: 200, 
//   h: 100
// })));
